import styled from 'styled-components';
import { Colors, FontFamilies, Media } from 'enums/enumsUIKit';

type Props = {
  active: boolean;
};

export const CategoriesItemStyles = styled.div<Props>`
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${({ active }) => (active ? Colors.yellow1 : 'none')};

  &:first-child {
    margin: 0;
  }

  &:active {
    background-color: ${({ active, theme }) =>
      active ? Colors.yellow1 : theme.colors.white};
  }

  @media ${Media.mobile} {
    margin: 16px 0 0 0;
  }

  @media ${Media.notebook} {
    padding: 20px;
    margin: 10px 0 0 0;

    &:hover {
      background-color: ${({ active, theme }) =>
        active ? Colors.yellow1 : theme.colors.white};
      cursor: pointer;
    }
  }
`;

export const TitleStyled = styled.div`
  margin-left: 10px;
  font-family: ${FontFamilies.Inter};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 147%;
  @media ${Media.notebook} {
    font-size: 16px;
  }
`;
